import { Component, Input } from '@angular/core';

@Component({
    selector: 'datex-common-overlay',
    templateUrl: './overlay.component.html',
    styleUrls: ['./overlay.component.scss'],
    standalone: false
})
export class OverlayComponent {

  @Input()
  show: boolean;

  onClick(event: Event) {
    event.stopPropagation();
  }

}
